import * as React from "react";
import { ImageFlux } from "@components/ImageFlux";
import type { UsersViewEnvironmentType } from "@graphql/__generated__/types";
import styles from "./index.module.css";

type Props = {
  viewEnvironments: Array<UsersViewEnvironmentType>;
  onClick: (index: number) => void;
};

const EnvironmentSlide: React.FC<Props> = ({ viewEnvironments, onClick }) => {
  return (
    <ul className={styles.slide}>
      {viewEnvironments &&
        viewEnvironments.map((item, index) => (
          <li
            className={styles.item}
            key={item.id}
            onClick={(): void => onClick(index)}
          >
            <ImageFlux
              imageType={"viewEnvironment"}
              url={item.imageUrl}
              alt={""}
            />
            <p>{item.description}</p>
          </li>
        ))}
    </ul>
  );
};

export default EnvironmentSlide;
